var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('wt-header'),_c('router-view'),_c('wt-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }